export default __webpack_public_path__ + "static/media/icon_bubble_emoji_smile_white.d87623c0.svg";